import React from 'react'
import { isSameDay, format, isToday, isYesterday } from 'date-fns'
import scrollIntoView from 'scroll-into-view'
import { differenceInMinutes } from 'date-fns'
import { List } from 'immutable'

import getCommentDecoratorId from '@slite/editor/lib/plugins/CommentPlugin/utils/getCommentDecoratorId'

export const renderDate = (currentDate, previousDate) => {
  if (!previousDate || !isSameDay(currentDate, previousDate)) {
    const date = new Date(currentDate)
    let formattedDate = format(date, 'MMMM Do')
    if (isToday(date)) {
      formattedDate = 'Today'
    }
    if (isYesterday(date)) {
      formattedDate = 'Yesterday'
    }
    return (
      <div className="padding-horizontal-large margin-top-normal margin-bottom-normal shade-20 uppercase font-size-smaller font-weight-bold">
        {formattedDate}
      </div>
    )
  }
}

export const getCommentTime = commentDate => {
  const date = new Date(commentDate)
  return format(date, 'H:mm')
}

export const getCommentDate = commentDate => {
  const date = new Date(commentDate)
  return format(date, 'DD MMM')
}

export const scrollToInlineComment = (event, threadId) => {
  event.preventDefault()
  event.stopPropagation()
  const inlineComment = document.getElementById(getCommentDecoratorId(threadId))
  if (inlineComment) {
    scrollIntoView(inlineComment, { time: 1000, behavior: 'smooth' })
  }
}

const MAX_MINUTES_INTERVAL_TO_GROUP = 10

export const getCommentsWithAfterBefore = ({ comments }) => {
  return comments.reduce((memo, comment, index) => {
    return memo.push({
      comment,
      sameAuthorAfter:
        comments.get(index + 1) &&
        comments.get(index + 1).createdBy === comment.createdBy &&
        differenceInMinutes(
          comments.get(index + 1).createdAt,
          comment.createdAt
        ) < MAX_MINUTES_INTERVAL_TO_GROUP,
      sameAuthorBefore:
        index > 0 &&
        comments.get(index - 1) &&
        comments.get(index - 1).createdBy === comment.createdBy &&
        differenceInMinutes(
          comment.createdAt,
          comments.get(index - 1).createdAt
        ) < MAX_MINUTES_INTERVAL_TO_GROUP,
    })
  }, new List())
}
